import {
  deleteLocalStorageItem,
  formatDocument,
  setCookieByName,
} from "../../../../utils";
export function useUpdateCookies() {
  const updateCookies = (branch) => {
    window.localStorage.setItem(
      "easygestorweb_current_branch",
      JSON.stringify(branch)
    );
    setCookieByName("branch_owner_id", branch.id);
    setCookieByName("branch_owner_name", branch.name);
    setCookieByName("branch_state_name", branch.address.state);
    deleteLocalStorageItem("nfe");
    window.location.href = "/";
  };
  return updateCookies;
}

export function useBranchCardData() {
  const getBranchName = (branch) => {
    return branch.individual ? branch.name : branch.company.fancy_name;
  };
  const getBranchCPFCNPJ = (branch) => {
    return formatDocument(
      branch.individual ? branch.individual.cpf : branch.company.cnpj
    );
  };
  const getBranchPlan = (branch) => {
    return branch.branch_plan;
  };
  const getAvailableNotes = (branch) => {
    if(! branch.branch_plan){
      return null
    }
    let notesQuantity =
    branch.branch_plan.notes_quantity - branch.branch_plan.total_sended_notes;
    return notesQuantity <= 0 ? 0 : notesQuantity;
  };
  const branchCardData = (branch) => {
    const name = getBranchName(branch);
    const cpfCnpj = getBranchCPFCNPJ(branch);
    const branchPlan = getBranchPlan(branch);
    const availableNotas = getAvailableNotes(branch);

    return {
      name,
      cpfCnpj,
      branchPlan,
      availableNotas
    };
  };
  return branchCardData;
}



// WEBPACK FOOTER //
// ./src/views/AppViews/Branches/hooks/index.js